import React from 'react';
import { FadeInUp } from './FadeInUp';
export function Trust() {
  const scrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-24" data-id="element-103">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-104">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-105">
          <FadeInUp className="order-2 lg:order-1" data-id="element-106">
            <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3]" data-id="element-107">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800" alt="Asesoría financiera profesional" className="absolute inset-0 w-full h-full object-cover" data-id="element-108" />
            </div>
          </FadeInUp>

          <div className="order-1 lg:order-2" data-id="element-109">
            <FadeInUp data-id="element-110">
              <h2 className="text-3xl md:text-4xl font-bold text-deep-blue mb-6 leading-tight" data-id="element-111">
                Miles de familias ya están creciendo sus ahorros y protegiendo
                su futuro con un IUL.
              </h2>
            </FadeInUp>

            <FadeInUp delay={0.1} data-id="element-112">
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-113">
                No dejes el futuro de los tuyos al azar. Agenda tu asesoría y da
                el primer paso hoy hacia una tranquilidad financiera real y
                duradera.
              </p>
            </FadeInUp>

            <FadeInUp delay={0.2} data-id="element-114">
              <a href="#lead-form" onClick={scrollToForm} className="inline-block bg-deep-blue hover:bg-blue-900 text-white font-semibold text-lg px-8 py-4 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl" data-id="element-115">
                Agendar mi asesoría ahora
              </a>
            </FadeInUp>
          </div>
        </div>
      </div>
    </section>;
}